/**
 * @desc 获取门店虚拟号
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** store_id */
  store_id: string;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<defs.store.WrapResponse<string>>(
    `/storeapi/after/sale/store/virtual-phone`,
    {
      params,
      method: 'get',
      ...(config || {}),
    },
  );
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.WrapResponse<string>;
export default req;
